/**
 * 设置弹窗配置文件
 * 定义听写和跟读设置的选项和默认值
 */

// 播放次数选项（听写和跟读共用）
export const playCountOptions = [
  { value: 1, label: '1次' },
  { value: 2, label: '2次' },
  { value: 3, label: '3次' },
  { value: 4, label: '4次' },
  { value: 5, label: '5次' }
];

// 留白时长选项（听写和跟读共用）
export const pauseTimeOptions = [
  { value: 0.5, label: '0.5倍音频时长' },
  { value: 0.75, label: '0.75倍音频时长' },
  { value: 1, label: '1.0倍音频时长' },
  { value: 1.5, label: '1.5倍音频时长' },
  { value: 2, label: '2.0倍音频时长' },
  { value: 2.5, label: '2.5倍音频时长' },
  { value: 3, label: '3.0倍音频时长' }
];

// 播放语速选项（听写和跟读共用）
export const playSpeedOptions = [
  { value: 'slow', label: '慢速' },
  { value: 'normal', label: '正常' },
  { value: 'fast', label: '快速' }
];

// 播放顺序选项（听写和跟读共用）
export const orderOptions = [
  { value: 'asc', label: '正序' },
  { value: 'random', label: '乱序' }
];

// 跟读次数选项（仅跟读使用）
export const repeatCountOptions = [
  { value: 'playAfterAll', label: '播完读一次' },
  { value: 'playOneReadOne', label: '播一次读一次' }
];

/**
 * 听写设置配置
 */
export const dictationConfig = {
  title: '听写设置',
  settingItems: [
    {
      key: 'playCount',
      label: '播放次数',
      valueType: 'number',
      options: playCountOptions
    },
    {
      key: 'pauseTime',
      label: '留白时长',
      valueType: 'number',
      options: pauseTimeOptions
    },
    {
      key: 'playSpeed',
      label: '播放语速',
      valueType: 'string',
      options: playSpeedOptions
    },
    {
      key: 'order',
      label: '播放顺序',
      valueType: 'string',
      options: orderOptions
    }
  ],
  defaultSettings: {
    playCount: 2,
    pauseTime: 1,
    playSpeed: 'normal',
    order: 'asc'
  }
};

/**
 * 跟读设置配置
 */
export const readingConfig = {
  title: '跟读设置',
  settingItems: [
    {
      key: 'playCount',
      label: '播放次数',
      valueType: 'number',
      options: playCountOptions
    },
    {
      key: 'repeatCount',
      label: '跟读次数',
      valueType: 'string',
      options: repeatCountOptions
    },
    {
      key: 'pauseTime',
      label: '留白时长',
      valueType: 'number',
      options: pauseTimeOptions
    },
    {
      key: 'playSpeed',
      label: '播放语速',
      valueType: 'string',
      options: playSpeedOptions
    },
    {
      key: 'order',
      label: '播放顺序',
      valueType: 'string',
      options: orderOptions
    }
  ],
  defaultSettings: {
    playCount: 2,
    repeatCount: 'playAfterAll',
    pauseTime: 1,
    playSpeed: 'normal',
    order: 'asc'
  }
};

/**
 * 课文领读设置配置
 */
export const articleReadingConfig = {
  title: '课文领读设置',
  settingItems: [
    {
      key: 'playCount',
      label: '播放次数',
      valueType: 'number',
      options: playCountOptions
    },
    {
      key: 'repeatCount',
      label: '跟读次数',
      valueType: 'string',
      options: repeatCountOptions
    },
    {
      key: 'pauseTime',
      label: '留白时长',
      valueType: 'number',
      options: pauseTimeOptions
    },
    {
      key: 'playSpeed',
      label: '播放语速',
      valueType: 'string',
      options: playSpeedOptions
    }
  ],
  defaultSettings: {
    playCount: 2,
    repeatCount: 'playAfterAll',
    pauseTime: 1,
    playSpeed: 'normal'
  }
};

